<template>
    <div>
        <router-link class="flexbox-center floating-button" v-show="getSelectedTab === 'requests'" :to="{ name: 'enquiry' }">
            <span class="floating-button-label">Opret henvendelse</span>
            <icon class="medium-svg fill-white stroke-white" name="enquiry-add"></icon>
        </router-link>
        <router-link class="flexbox-center floating-button" v-show="getSelectedTab === 'tasks'" :to="{ name: 'task' }">
            <span class="floating-button-label">Opret opgave</span>
            <icon class="medium-svg fill-white stroke-white" name="task-add"></icon>
        </router-link>
        <router-link class="flexbox-center floating-button" v-show="getSelectedTab === 'routines'" :to="{ name: 'task' }">
            <span class="floating-button-label">Opret rutineopgave</span>
            <icon class="medium-svg fill-white stroke-white" name="task-add"></icon>
        </router-link>
        <!-- <router-link class="flexbox-center show-for-small-only floating-button" v-show="getSelectedTab === 'requisitions'" :to="{ name: 'map' }">
            <span class="floating-button-label">Åbn kort</span>
            <icon class="medium-svg fill-white stroke-white" name="maplocation"></icon>
        </router-link> -->
        <router-link class="flexbox-center floating-button" v-show="getSelectedTab === 'templates'" :to="{ name: 'tasktemplate' }">
            <span class="floating-button-label">Opret skabelon</span>
            <icon class="medium-svg fill-white stroke-white" name="template-add" style="margin-right: -10px;"></icon>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            getSelectedTab: 'getSelectedTab'
        })
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/floating-button.scss';
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/dashboard-new-work.vue